export const maximumDelay = 2764800000;
